/* Originelo: premium icons loop while visible; delivery van drives the map routes. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-animated', e.isIntersecting); }); }, { threshold: 0.35 });
    document.querySelectorAll('.org-anim').forEach(function (el) { io.observe(el); });
  }
  if (reduce) return;
  document.querySelectorAll('.org-delivery__map').forEach(function (map) {
    var van = map.querySelector('#van');
    var routes = [1, 2, 3, 4, 5, 6].map(function (i) { return map.querySelector('#route-' + i); }).filter(Boolean);
    if (!van || !routes.length) return;
    var i = 0, t0 = null, dur = 3200, pause = 600;
    function f(ts) {
      if (t0 === null) t0 = ts;
      var r = routes[i], L = r.getTotalLength(), e = ts - t0, k = Math.min(e / dur, 1);
      var p = r.getPointAtLength(k * L), q = r.getPointAtLength(Math.min(k * L + 1, L));
      van.setAttribute('transform', 'translate(' + p.x + ' ' + p.y + ')' + (q.x < p.x ? ' scale(-1 1)' : ''));
      if (e > dur + pause) { i = (i + 1) % routes.length; t0 = ts; }
      requestAnimationFrame(f);
    }
    requestAnimationFrame(f);
  });
})();
/* product page: delivery date range + tabs */
(function () {
  function addBD(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  var o = { weekday: 'short', day: '2-digit', month: '2-digit' };
  var loc = (document.documentElement.lang || 'de').toLowerCase().indexOf('fr') === 0 ? 'fr-FR' : 'de-DE';
  document.querySelectorAll('[data-org-eta]').forEach(function (el) {
    var a = parseInt(el.dataset.min, 10), b = parseInt(el.dataset.max, 10);
    if (a && b) el.textContent = addBD(a).toLocaleDateString(loc, o) + ' – ' + addBD(b).toLocaleDateString(loc, o);
  });
  document.querySelectorAll('[data-org-tabs]').forEach(function (box) {
    var tabs = box.querySelectorAll('[role=tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
      });
    });
  });
})();

/* localized storefront (e.g. /fr): links typed as "/pages/…" in theme settings get the language prefix */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;
  var skip = /^\/(cdn|apps|services|tools|checkouts?|cart\/(add|change|update|clear))(\/|$)/;
  document.querySelectorAll('a[href^="/"]').forEach(function (a) {
    var h = a.getAttribute('href');
    if (h.indexOf('//') === 0 || h.indexOf(root) === 0 || h === root.replace(/\/$/, '') || skip.test(h)) return;
    a.setAttribute('href', root + h.replace(/^\//, ''));
  });
})();
